import Cookies from "js-cookie";

const getUserAICard = async ({ commit, rootGetters, dispatch }, payload) => {
    commit("SET_USER_AI_CARD_LOADING", true);
    try {
        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];
        const data = { ...payload, userId: Cookies.get('userId'), customer_id: customer.customer_id };

        if (customer.customer_id === 0) {
            data.customer_id = selected_customer.customer_id;
        }

        const response = await window.axios.get(`/proxy/ai/settings/${data.userId}/user-ai-card?customer_id=${data.customer_id}`, data);
        if (response && response.data.success) {
            commit("SET_USER_AI_CARD", response.data.card);
        } else {
            throw response.data;
        }
    } catch (error) {
        dispatch("notifications/setError", error.message, { root: true });
    } finally {
        commit("SET_USER_AI_CARD_LOADING", false);
    }
};

export default getUserAICard;